<template>
<div class="text-left">
  <div class="md:h-full md:w-full m-auto">
    <div>
      <span class="block mb-4 text-center text-4xl md:text-7xl font-bold tracking-tight text-gray-700 dark:text-white"><strong>{{$t('interior')}}</strong></span>
      <span v-html="$t('interior_prompt')" class="block mb-2 text-center text-x md:text-2xl font-bold tracking-tight text-gray-700 dark:text-white"></span>
    </div>
  </div>
  <div class="container lg:px-32 px-4 py-8 mx-auto items-center ">
    <div class="grid grid-cols-4 grid-rows-1 grid-flow-row gap-2">
      <div class="w-full">
        <img
          src="../assets/images/interior/modern.png"
          alt="Photo by Claudio Schwarz on Unsplash"
          class="inset-0 w-full object-cover object-center rounded-lg opacity-100 hover:opacity-100 ">
      </div>
      <div class="w-full">
        <img
          src="../assets/images/interior/minimalist.png"
          alt="Photo by Claudio Schwarz on Unsplash"
          class="inset-0 w-full object-cover object-center rounded-lg opacity-100 hover:opacity-100 ">
      </div>
      <div class="w-full">
        <img
          src="../assets/images/interior/contemporary.png"
          alt="Photo by Claudio Schwarz on Unsplash"
          class="inset-0 w-full object-cover object-center rounded-lg opacity-100 hover:opacity-100 ">
      </div>
      <div class="w-full">
        <img
          src="../assets/images/interior/scandinavian.png"
          alt="Photo by Claudio Schwarz on Unsplash"
          class="inset-0 w-full object-cover object-center rounded-lg opacity-100 hover:opacity-100 ">
      </div>
    </div>
  </div>

  <div class="md:h-full md:w-full m-auto">
    <div>
      <span class="block mb-4 text-center text-2xl md:text-5xl font-bold tracking-tight text-gray-700 dark:text-white"><strong>Start using AI Powered Interior Design</strong></span>
      <span class="block mb-2 text-center text-lg md:text-x font-bold tracking-tight text-gray-700 dark:text-white">
        
      </span>
    </div>
  </div>
  <div class="flex flex-wrap justify-center md:mt-10 md:mb-10">
    <div class="md:h-full md:w-1/2 pl-2 pr-2">
      <p style="font-size:30px; padding-bottom:10px; font-weight:bold;">Usage Guideline</p>
      <p style="font-size:16px; padding-bottom:10px; font-weight:bold;">Take a photo of your current room. For best results make sure it shows the entire room in a 90° straight angle facing a wall or window horizontally (click for example). Not from a corner or angled, and not a wide angle photo as it's trained on regular photos. The AI isn't great at angled pics (yet)! Uploads + renders are shown on site but auto deleted after 15 mins. To make 100% private HQ renders without deletion and watermark upgrade to Pro and you get your own private workspace.</p>
      <p style="font-size:14px; padding-bottom:10px; font-weight:bold; font-style: italic;">The better you follow these guideline, the better your AI design :)</p>
    </div>
    <div class="md:h-full md:w-1/2 pl-2 pr-2">
      <div class="rounded overflow-hidden shadow-md mx-auto px-10 m-5">
      <div class="mb-2">
          <label for="email" class="block mb-2 text-lg font-medium text-gray-900 dark:text-gray-300">Your real email (in order to send generated interior design)</label>
          <input v-model="user.email" type="email" id="email" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required>
      </div>
      <div class="md:h-full md:w-full">
        <button type="button" @click="chargeForAProduct" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Confirm your email</button>
      </div>
      <div class="mb-2">
        <label for="who" class="block mb-2 text-lg font-medium text-gray-900 dark:text-gray-300">Your current interior?</label>
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="100">
            mdi-cloud-upload
          </v-icon>
          <p class="block mb-2 text-lg font-medium text-gray-900 dark:text-gray-300">
            Drop your images here, or click to select them.
          </p>
        </v-row>
      </div>
      <div class="mb-2">
        <label for="room" class="block mb-2 text-lg font-medium text-gray-900 dark:text-gray-300">Room</label>
        <select name="room" id="">
          <option value="">Living Room</option>
          <option value="">Kitchen</option>
          <option value="">Bedroom</option>
        </select>
      </div>
      <div class="mb-2">
        <label for="style" class="block mb-2 text-lg font-medium text-gray-900 dark:text-gray-300">Style</label>
        <select name="style" id="">
          <option value="">Modern</option>
          <option value="">Minimalist</option>
          <option value="">Contemporary</option>
          <option value="">Scandinavian</option>
        </select>
      </div>
      <div class="md:h-full md:w-full">
        <button type="button" @click="chargeForAProduct" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">Render Now</button>
      </div>
    </div>
      
    </div>
  </div>

</div>
</template>

<script>
import { paddleVendorId } from '../settings';

export default {
  name: "Interior",
  components: {
  },
  props: {
  },
  data() {
    return {
      origin: 'http://localhost:8080',
      user: {
        email: ''
      }
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  async mounted() {
    let paddleScript = document.createElement('script')
    paddleScript.setAttribute('src', 'https://cdn.paddle.com/paddle/paddle.js')
    
    paddleScript.onload = () => {
      if(process.env.NODE_ENV !== 'production')
      {
        window.Paddle.Environment.set('sandbox')
      }

      window.Paddle.Setup({
        vendor: paddleVendorId
      });
    };

    document.head.appendChild(paddleScript);
  },
  methods: {
    chargeForAProduct(){
      var vm = this;
      window.Paddle.Checkout.open({
          product: '26468',
          email: vm.user.email,
          successCallback: function(data) {
              vm.checkoutStatus = data;
              vm.checkoutStatusDialog = true;
          },
          closeCallback: function() {
          }
      });
    },
  },
};
</script>